import styled, { css } from 'styled-components';

export default styled('div')`
  ${({ theme }) => css`
    margin: 0 auto;
    max-width: ${theme.dimensions.widescreen}px!important;
  `}
`;
